import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { Router } from '@angular/router';
import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { FooterService } from '../../components/footer/footer.service';
import { HttpClient } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { AdminLayoutService } from '../../layouts/admin-layout/admin-layout.service';
import { Meta, Title } from '@angular/platform-browser';

declare const $: any;
const countryData = require('../country-code.json');

@Component({
    selector: 'app-bookings',
    templateUrl: './bookings.component.html',
    styleUrls: ['./bookings.component.css']
})
export class BookingsComponent implements OnInit {
    guestLogin: boolean;
    currentBookingDataList: any = [];
    pastBookingDataList: any = [];
    guestBookingDetails: any = [];
    itineraryDataList: any = [];
    bookingDataList: any = [];
    userId: any;
    bookingId: any;
    isCurrentBooking: Boolean = true;
    noBookingData: boolean = false;
    selectedTravelerIndex: number | null = null;
    images: any = [];
    imagePreviews: string[] = [];
    countries: any[] = [];
    selectedCountryCode: string = '+1';
    dropdownStates: boolean[] = [true];
    formattedCancellationDeadline: string = '';
    formattedAfterDeadline: string = '';
    cancellationFee: number = 0;
    cancellationAvailable: boolean = false;
    isAgreed: boolean = false;
    stars = [1, 2, 3, 4, 5];

    isCancelConfirmed = false;
    showConfirmationPopup: boolean = false; // Control visibility of popup


    countryData = countryData;

    selectedMember: any = {
        name: '',
        gender: '',
        age: '',
        email: '',
        password: '',
        countryCode: '',
        mobileNumber: ''
    };

    feedbackData: any = {
        bookingId: '',
        placeId: '',
        bookingNo: '',
        tourManager: 0,
        travelArrangement: 0,
        accommodation: 0,
        foodAndBeverages: 0,
        comment: '',
        email: '',
        mobileNumber: '',
        countryCode: '',
    };


    @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
    showCancelButton: boolean;
    isZeroCancellation: boolean;
    isNonRefundableZero: boolean;
    cancellationPolicies: { cancellationDeadline: any; cancellationFeeAmount: number; formattedAfterDeadline: string; isNonRefundable: boolean; }[];

    constructor(private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        public storageService: StorageService,
        public commonService: CommonService,
        public userLayoutService: UserLayoutService,
        public adminLayoutService: AdminLayoutService,
        private footerService: FooterService,
        private fb: FormBuilder, private meta: Meta, private title: Title
    ) { }

    ngOnInit(): void {
        this.metaTagAdd()  //////  Meta tags add for SEO  //////
        this.footerService.hideFooter();
        this.userId = localStorage.getItem("_id");
        this.guestLogin = this.userId === null;
        if (this.userId) {
            this.getCurrentBookingDetails();
            this.getPastBookingDetails();
        }
        this.feedbackData.bookingId = '12345';
        this.feedbackData.placeId = '67890';
        this.feedbackData.bookingNo = 'REF123456';
        this.fetchCountries();
        // setTimeout(() => {
        //     this.getPackegeDetailsbybookingId('6b55d77b-9c22-499b-a581-572790eec599');
        // }, 100);
    }
    metaTagAdd() {
        this.title.setTitle('Bookings | My Yatra 360 — Secure Your Travel Instantly');

        this.meta.updateTag({
            name: 'description',
            content: 'Book your dream trip with ease. Secure flights, hotels, tours and more through My Yatra 360. Fast, reliable, and hassle-free booking.'
        });

        this.meta.updateTag({
            name: 'keywords',
            content: 'Bookings'
        });

    }
    bookingFilter() {
        this.isCurrentBooking = !this.isCurrentBooking;
    }

    getCurrentBookingDetails() {
        let dataObj = {
            userId: this.userId,
        }
        this.userLayoutService.getCurrentBookingDetailsByUserId(dataObj).subscribe((Response: any) => {

            if (Response.code == 1) {
                this.currentBookingDataList = Response.data.map((booking: any) => {
                    const start = new Date(booking.startDate);
                    const end = new Date(booking.endDate);

                    const timeDiff = end.getTime() - start.getTime();

                    const totalDay = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
                    const totalNight = totalDay - 1;

                    return {
                        ...booking,
                        totalDay,
                        totalNight
                    };
                });
            }

            else {
                Response.error
            }
        }, (error) => {
            // console.log(error.error.Message);
        });
    }

    fetchCountries() {
        this.http.get<any[]>('https://restcountries.com/v3.1/all').subscribe(
            (data) => {
                this.countries = data.map((country) => {
                    return {
                        name: country.name.common,
                        dialCode: `${country.idd?.root}${country.idd?.suffixes ? country.idd.suffixes[0] : ''}`,
                        flag: country.flags.png,
                    };
                });
            },
            (error) => {
                console.error('Error fetching country data', error);
            }
        );
    }

    getPackegeDetailsbybookingId(BookingId: any) {
        this.images = [];
        this.imagePreviews = [];
        this.fileInput.nativeElement.value = '';

        this.userLayoutService.getCurrentBookingDetailsById(BookingId).subscribe((Response: any) => {

            if (Response.code == 1) {
                this.bookingId = BookingId;
                this.bookingDataList = Response.data;
                this.showCancelButton = this.bookingDataList.bookingStatus !== 'Cancelled';
                $("#tourDetails").offcanvas('show');
                this.selectedTravelerIndex = 0;
            }
            else {
                Response.error
            }
        }, (error) => {
            // console.log(error.error.Message);
        });
    }

    getPastBookingDetails() {
        let dataObj = {
            userId: this.userId,
        }
        this.userLayoutService.getPastBookingDetailsByUserId(dataObj).subscribe((Response: any) => {

            if (Response.code == 1) {
                this.pastBookingDataList = Response.data.map((booking: any) => {
                    const start = new Date(booking.startDate);
                    const end = new Date(booking.endDate);

                    const timeDiff = end.getTime() - start.getTime();

                    const totalDay = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
                    const totalNight = totalDay - 1;

                    return {
                        ...booking,
                        totalDay,
                        totalNight
                    };
                });
            } else if (Response.code == 2) {
                this.pastBookingDataList = [];
                // console.log(this.pastBookingDataList);
            }
            else {
                Response.error
            }
        }, (error) => {
            // console.log(error.error.Message);
        });
    }
    toggleDropdown(index: number): void {
        // this.dropdownStates[index] = !this.dropdownStates[index];
        this.dropdownStates = this.dropdownStates.map((_, i) => i === index ? !this.dropdownStates[i] : false);
    }
    getItineraryData(bookingId: any): void {
        this.itineraryDataList = [];
        this.adminLayoutService.getItineraryDataByBookingId(bookingId).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    const totalDropdowns = response.data.length;
                    this.dropdownStates = Array(totalDropdowns).fill(false);
                    this.dropdownStates[0] = true;
                    this.itineraryDataList = response.data || [];
                    // console.log(this.itineraryDataList);
                    $("#tourDetails").offcanvas('hide');
                    $("#itineraryDetails").modal('show');
                } else {
                    this.itineraryDataList = [];
                    // this.noData = true;
                    // console.warn('Failed to retrieve package details');
                    this.commonService.notifier.notify('error', response.message);

                }
            },
            (error) => {
                // console.error('Error fetching package details:', error.error?.Message || error);
                this.commonService.notifier.notify('error', error.error.message || error);
            }
        );
    }

    searchBookingDetailsByRefNo(searchKey: string) {
        if (!searchKey) {
            this.guestBookingDetails = [];
            this.showCancelButton = false; // Hide cancel button initially
            return;
        }
        this.userLayoutService.guestBookingDetails({ searchKey: searchKey }).subscribe((response: any) => {
            if (response.code === 1) {
                this.guestBookingDetails = response.data.map((booking: any) => {
                    const start = new Date(booking.startDate);
                    const end = new Date(booking.endDate);

                    // Calculate the difference in milliseconds
                    const timeDiff = end.getTime() - start.getTime();

                    // Calculate total days and nights
                    const totalDay = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
                    const totalNight = totalDay - 1;

                    return {
                        ...booking,
                        totalDay,
                        totalNight
                    };
                });
                this.noBookingData = false;

                // Check if there is at least one booking that is not cancelled
                // this.showCancelButton = this.guestBookingDetails.some(booking => 
                //   booking.status !== 'Booking Cancelled' && booking.status !== 'Cancelled');

                // console.log("guestbooking", this.guestBookingDetails);
            } else {
                this.guestBookingDetails = [];
                this.noBookingData = true;
            }
        }, (error) => {
            this.guestBookingDetails = [];
            this.noBookingData = true;
        });
    }


    closeUpperModel(modal: string, offcanvas: string) {
        if (modal) {
            $(`#${modal}`).modal('hide');
        }
        if (offcanvas) {
            $(`#${offcanvas}`).offcanvas('hide');
        }
        $("#tourDetails").offcanvas('show');
    }

    packageDetails(placeId: any) {
        this.router.navigate(['packages-details'], {
            queryParams: { PlaceId: placeId }
        });
    }

    get currentTraveler() {
        return this.selectedTravelerIndex !== null
            ? this.bookingDataList.travelerInfoArray[this.selectedTravelerIndex]
            : null;
    }

    selectTraveler(index: number) {
        this.selectedTravelerIndex = index;
    }

    editTraveler(id: any) {
        this.userLayoutService.GetFamilyMemberById({ id }).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    this.selectedMember = response.data;
                    if (!this.selectedMember.countryCode) {
                        this.selectedMember.countryCode = '+1';
                    }
                    $("#editinformationModal").modal('show');
                } else {
                    this.commonService.notifier.notify('error', response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', 'Failed to fetch family member data');
            }
        );
    }

    onUpdateMember(): void {
        this.closeUpperModel(null, 'editinformationSidebar');
        this.closeUpperModel1(null, 'tourDetails');
        this.userLayoutService.UpdateFamilyMember(this.selectedMember).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    this.commonService.notifier.notify('success', 'Family member updated successfully');
                    $('#editinformationModal').modal('hide');

                    // Cleanup fallback after hiding
                    setTimeout(function () {
                        $('.modal-backdrop').remove();
                        $('body').removeClass('modal-open');
                    }, 500);
                } else {
                    this.commonService.notifier.notify('error', response.message);
                }

            },
            (error) => {
                // console.log('Update Family Member API Error:', error);
                this.commonService.notifier.notify('error', 'Failed to update family member');
            }
        );
    }

    closeUpperModel1(modal: string | null, offcanvas: string | null) {
        if (modal) {
            $(`#${modal}`).modal('hide');
        }
        if (offcanvas) {
            $(`#${offcanvas}`).offcanvas('hide');
        }
    }


    onFileSelected(event: Event): void {
        const target = event.target as HTMLInputElement;
        const files = target.files;

        if (files) {
            let selectedImages = Array.from(files);
            this.images = this.images.concat(selectedImages);
            selectedImages.forEach(file => {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    this.imagePreviews.push(e.target.result);
                };
                reader.readAsDataURL(file);
            });

            this.fileInput.nativeElement.value = '';
        }
    }

    updateRating(field: string, rating: number): void {
        this.feedbackData[field] = rating;
    }

    removeImage(index: number): void {
        this.imagePreviews.splice(index, 1);

        this.images.splice(index, 1);
    }

    Getfeedback(bookingNo: string): void {
        if (!bookingNo) {
            console.error('Invalid bookingNo passed to Getfeedback:', bookingNo);
            return;
        }
        this.feedbackData.bookingNo = bookingNo;
        // console.log('Feedback initialized for Booking No:', bookingNo);
    }



    onShareImages(): void {
        const formData = new FormData();
        formData.append('userId', this.userId || '');
        formData.append('bookingId', this.bookingId);
        this.images.forEach((image) => {
            const timestamp = Date.now();
            const updatedName = `${timestamp}_${image.name}`;
            const imageWithTimestamp = new File([image], updatedName, { type: image.type });

            formData.append('image', imageWithTimestamp, updatedName);
        });

        // console.log(formData)

        this.userLayoutService.addShareImages(formData).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    this.commonService.notifier.notify('success', 'Images Shared successfully');
                } else {
                    this.commonService.notifier.notify('error', response.message);
                }
            },
            (error) => {
                // console.log('Share Images API Error:', error);
                this.commonService.notifier.notify('error', 'Failed to Share Images');
            }
        );
    }

    openGiveFeedback() {
        this.feedbackData = {
            bookingId: '',
            placeId: '',
            bookingNo: '',
            tourManager: 0,
            travelArrangement: 0,
            accommodation: 0,
            foodAndBeverages: 0,
            comment: '',
            email: '',
            mobileNumber: '',
            countryCode: '+1'
        };
        // $("#givefeedback").offcanvas('show');
        $("#feedbackModal").modal('show');

    }

    submitFeedback(): void {
        // if (!this.feedbackData.bookingNo) {
        //     this.commonService.notifier.notify('error', 'Booking number is required');
        //     return;
        // }
        // this.userLayoutService.addFeedback(this.feedbackData).subscribe(
        //     (response: any) => {
        //         if (response.code === 1) {
        //             this.commonService.notifier.notify('success', 'Feedback submitted successfully');
        //             // Reset the form after successful submission
        //             this.feedbackData = {
        //                 bookingId: '',
        //                 placeId: '',
        //                 bookingNo: '',
        //                 tourManager: 0,
        //                 travelArrangement: 0,
        //                 accommodation: 0,
        //                 foodAndBeverages: 0,
        //                 comment: '',
        //                 email: '',
        //                 mobileNumber: '',
        //                 countryCode: '+1'
        //             };
        //         } else {
        //             this.commonService.notifier.notify('error', response.message);
        //         }
        //     },
        //     (error) => {
        //         this.commonService.notifier.notify('error', 'Failed to submit feedback');
        //     }
        // );
    }

    mobilenumberInput(event: any): void {
        const input = event.target;
        input.value = input.value.replace(/[^0-9]/g, '');
    }

    searchByName(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) || item.dialCode.toLowerCase().includes(term);
    }

    medicalDetails(travelerId: any) {
        // console.log(travelerId)
        this.router.navigate(['medications'], {
            queryParams: { travelerId: travelerId }
        });
    }

    onImageError(event: any) {
        event.target.src = 'assets/images/safenet_logo_new.png';
    }

    searchByName1(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
    }

    // cancelBooking(bookingId: string): void {
    //   // Step 1: Show confirmation dialog
    //   const bookingid = bookingId;

    //   const confirmation = window.confirm('Are you sure you want to cancel this booking?');

    //   if (confirmation) {
    //     // Step 2: Proceed with cancellation
    //     const bookingId = bookingid;  // Package ID to pass to the backend

    //     // Step 3: Call the API to handle cancellation
    //     this.recordCancellation(bookingId);
    //   }
    // }

    // recordCancellation(bookingId: string): void {
    //   // This function will save the packageId to your backend for cancellation

    //   const cancellationData = {
    //     bookingId: bookingId  // Only pass the packageId to the API
    //   };

    //   // Assuming you have a service to handle saving the data to your backend or table
    //   this.adminLayoutService.saveCancellationData(cancellationData).subscribe(
    //     (response) => {
    //       if (response[0].code == 1) {
    //         this.commonService.notifier.notify('success', 'Booking cancelled successfully');
    //         console.log('Cancellation request submitted successfully:', response);
    //       } else {

    //         console.error('Error submitting cancellation request:', response);
    //       }
    //     },
    //     (error) => {
    //       this.commonService.notifier.notify('error', error.error.message || error);
    //       console.error('Error submitting cancellation request:', error);
    //     }
    //   );
    // }

    cancelBooking(bookingId: string): void {
        $("#tourDetails").offcanvas('hide');
        $("#cancelConfirmationModal").modal('show');
        this.calculateCancellationPolicies();
    }

    closeConfirmationModal(): void {
        $('#cancelConfirmationModal').modal('hide');
        $("#tourDetails").offcanvas('show');
    }

    confirmCancellation(): void {
        if (this.isAgreed) {
            // Create the cancellation data with the bookingId and userEmail
            const cancellationData = {
                bookingId: this.bookingDataList.bookingId,
                userEmail: this.bookingDataList.userEmail // Pass the email from booking data
            };

            // Pass the cancellationData to recordCancellation method
            this.recordCancellation(cancellationData);

            // Close the confirmation modal
            $('#cancelConfirmationModal').modal('hide');
        } else {
            // Notify the user to agree to the cancellation policy
            this.commonService.notifier.notify('error', 'You must agree to the cancellation policy.');
        }
    }


    recordCancellation(cancellationData: any): void {
        // Include UserEmail in the cancellationData
        cancellationData.UserEmail = this.bookingDataList.userEmail;
        const updatedCancellationData = {
            ...cancellationData,
            UserEmail: cancellationData.UserEmail
        };

        // Call API to record the cancellation and send the email
        this.userLayoutService.saveCancellationData(updatedCancellationData).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    this.commonService.notifier.notify('success', response.message);
                    // console.log('Cancellation request submitted successfully:', response);
                } else {
                    console.error('Error submitting cancellation request:', response);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error.error.message || error);
                console.error('Error submitting cancellation request:', error);
            }
        );
    }



    // calculateCancellationPolicy(): void {
    //   const cancellationDaysBefore = this.bookingDataList.cancellationDaysBefore;
    //   const cancellationCharge = this.bookingDataList.cancellationCharge;

    //   this.isNonRefundableZero = (cancellationDaysBefore === 0 || cancellationCharge === 0); // Directly set the flag

    //   if (this.isNonRefundableZero) {
    //       return; // Exit early if it's immediately non-refundable
    //   }

    //   const bookingStartDate = new Date(this.bookingDataList.startDate);
    //   const today = new Date();

    //   let cancellationDeadline = new Date(bookingStartDate);
    //   cancellationDeadline.setDate(cancellationDeadline.getDate() - cancellationDaysBefore);

    //   this.cancellationAvailable = today <= cancellationDeadline; // Simplified check

    //   if (this.cancellationAvailable) {
    //       this.formattedCancellationDeadline = cancellationDeadline.toLocaleDateString('en-US', {
    //           day: '2-digit',
    //           month: 'short',
    //           year: 'numeric',
    //       });
    //       const totalAmount = this.bookingDataList.totalAmount || 0;
    //       this.cancellationFee = Math.round(totalAmount * (cancellationCharge / 100) * 100) / 100;
    //   }
    // }




    // calculateCancellationPolicy(): void {
    //     const policies = this.bookingDataList.cancellationPolicies; // Array of { day, returnRation }
    //     const today = new Date();
    //     const bookingStartDate = new Date(this.bookingDataList.startDate);

    //     if (!policies || policies.length === 0) {
    //         // No policies available, set default non-refundable
    //         this.isNonRefundableZero = true;
    //         return;
    //     }

    //     // Sort policies by day (ascending)
    //     policies.sort((a: any, b: any) => a.day - b.day);

    //     this.isNonRefundableZero = false;
    //     this.cancellationAvailable = false;
    //     this.cancellationFee = 0;

    //     for (const policy of policies) {
    //         const cancellationDeadline = new Date(bookingStartDate);
    //         cancellationDeadline.setDate(cancellationDeadline.getDate() - policy.day);

    //         if (today <= cancellationDeadline) {
    //             // This policy applies
    //             this.cancellationAvailable = true;
    //             this.formattedCancellationDeadline = cancellationDeadline.toLocaleDateString('en-US', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric',
    //             });

    //             const totalAmount = this.bookingDataList.totalAmount || 0;
    //             this.cancellationFee = Math.round(totalAmount * (policy.returnRation / 100) * 100) / 100;
    //             break; // Stop checking further policies
    //         }
    //     }

    //     // If no policy is applicable
    //     if (!this.cancellationAvailable) {
    //         this.isNonRefundableZero = true;
    //     }
    // }


    calculateCancellationPolicies(): void {
        const policies = this.bookingDataList.cancellationPolicies; // Array of { day, returnRation }
        const bookingStartDate = new Date(this.bookingDataList.startDate);

        // Default to non-refundable if no policies are present
        if (!policies || policies.length === 0) {
            this.cancellationPolicies = [
                {
                    cancellationDeadline: null,
                    cancellationFeeAmount: 0,
                    formattedAfterDeadline: 'Non-Refundable',
                    isNonRefundable: true,
                },
            ];
            return;
        }

        // Sort policies by the number of days (ascending)
        policies.sort((a: any, b: any) => a.day - b.day);

        const calculatedPolicies = policies.map((policy: any) => {
            const cancellationDeadline = new Date(bookingStartDate);
            cancellationDeadline.setDate(cancellationDeadline.getDate() - policy.day);

            const totalAmount = this.bookingDataList.totalAmount || 0;
            const cancellationFeeAmount = Math.round(totalAmount * (policy.returnRation / 100) * 100) / 100;

            return {
                cancellationDeadline,
                cancellationFeeAmount,
                formattedCancellationDeadline: cancellationDeadline.toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                }),
                isNonRefundable: false,
            };
        });

        // Sort by cancellation deadline (earliest first)
        calculatedPolicies.sort((a: any, b: any) => a.cancellationDeadline - b.cancellationDeadline);

        // Add the "non-refundable" section after the last policy if there are any policies
        if (calculatedPolicies.length > 0) {
            const lastPolicy = calculatedPolicies[calculatedPolicies.length - 1];
            calculatedPolicies.push({
                cancellationDeadline: null,
                cancellationFeeAmount: 0,
                formattedAfterDeadline: `After ${lastPolicy?.formattedCancellationDeadline ||
                    bookingStartDate.toLocaleDateString('en-US', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                    })
                    }`,
                isNonRefundable: true,
            });
        }

        this.cancellationPolicies = calculatedPolicies;
    }




    // calculateCancellationPolicies(): void {
    //   const policies = this.bookingDataList.cancellationPolicies; // Array of { day, returnRation }
    //   const bookingStartDate = new Date(this.bookingDataList.startDate);

    //   // Default to non-refundable if no policies are present
    //   if (!policies || policies.length === 0) {
    //     this.cancellationPolicies = [
    //       {
    //         cancellationDeadline: null,
    //         cancellationFeeAmount: 0,
    //         formattedAfterDeadline: 'Non-Refundable',
    //         isNonRefundable: true,
    //       },
    //     ];
    //     return;
    //   }

    //   // Sort policies by the number of days (ascending)
    //   policies.sort((a: any, b: any) => a.day - b.day);

    //   const calculatedPolicies = policies.map((policy: any) => {
    //     const cancellationDeadline = new Date(bookingStartDate);
    //     cancellationDeadline.setDate(cancellationDeadline.getDate() - policy.day);

    //     const totalAmount = this.bookingDataList.totalAmount || 0;
    //     const cancellationFeeAmount = Math.round(totalAmount * (policy.returnRation / 100) * 100) / 100;

    //     return {
    //       cancellationDeadline,
    //       cancellationFeeAmount,
    //       formattedCancellationDeadline: cancellationDeadline.toLocaleDateString('en-US', {
    //         day: '2-digit',
    //         month: 'short',
    //         year: 'numeric',
    //       }),
    //       isNonRefundable: false,
    //     };
    //   });

    //   // Sort by cancellation deadline (earliest first)
    //   calculatedPolicies.sort((a: any, b: any) => a.cancellationDeadline - b.cancellationDeadline);

    //   // Add the "non-refundable" section after the last policy
    //   const lastPolicy = calculatedPolicies[calculatedPolicies.length - 1];
    //   calculatedPolicies.push({
    //     cancellationDeadline: null,
    //     cancellationFeeAmount: 0,
    //     formattedAfterDeadline: `After ${
    //       lastPolicy?.formattedCancellationDeadline ||
    //       bookingStartDate.toLocaleDateString('en-US', {
    //         day: '2-digit',
    //         month: 'short',
    //         year: 'numeric',
    //       })
    //     }`,
    //     isNonRefundable: true,
    //   });

    //   this.cancellationPolicies = calculatedPolicies;
    // }








}
